import React, {useEffect,useState} from 'react'
import "../styles/LoginForm.css"
import {Link} from "react-router-dom";

// import TextField from '@material-ui/core/TextField'
import { Button, TextField } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { userActions } from '../actions/user.actions'
import {useSelector,useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'

function LoginForm() {
    
    return (
        <div className="loginMain">
            <div className="loginContainer">
                <h3>NMO Admin Portal</h3>
                <h4>Enter Email To Get OTP</h4>
                <Formik>
                    {
                        () => (
                            <Form>
                                  <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                  <Field name="userid" as={TextField}  label="Email" variant="outlined" />
                                    {/* <div style={{position:'fixed',left:'795px',top:'316px'}}>{passwordShown?  <i class="fa fa-eye  openbtn"  onClick={handleshow}></i>: <i class="fa fa-eye-slash  openbtn"  onClick={handlePass}></i>}</div>  */}
                                    <Button variant="contained" color="primary" type="submit">Send OTP</Button>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default LoginForm
